export type D2CBackgroundColor = "black" | "white" | "whitesmoke";
export type D2CHeadlineColor = "black" | "white" | "alabastergrey";
export type D2CTextColor = "black" | "white" | "alabastergrey";

export interface D2CDerivedTextColors {
  headlineColor: D2CHeadlineColor;
  textColor: D2CTextColor;
}

/**
 * Derives the D2C headline and body-text colors from a section's background
 * color.
 *
 * In production this mapping lives in the Contentful `UiConfigurationAdapter`
 * (apps/d2c-web), so authors only pick a background color and the text colors
 * follow automatically. The presentational components in this package receive
 * those colors as finished props and never derive them — which is why Storybook
 * (which renders the components directly, without the adapter) does not reflect
 * the automatic behavior. Stories use this helper to reproduce it.
 *
 * Keep this in sync with `UiConfigurationAdapter`.
 */
export function deriveD2CTextColors(
  backgroundColor?: D2CBackgroundColor | null
): D2CDerivedTextColors {
  const isDarkBackground = backgroundColor === "black";

  return {
    headlineColor: isDarkBackground ? "white" : "black",
    textColor: isDarkBackground ? "alabastergrey" : "black",
  };
}
